export const REQUEST_TIMEOUT = 5 * 60 * 1000
export const FRIENDLY_CAPTCHA_SITEKEY = 'FCMSDF99SJRQIVO9'
